import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as WarningIcon } from '../../../../../assets/images/warningIcon.svg';
import Button from '../../../../../components/shared/Button/Button';
import Modal from '../../../../../components/shared/Modal/Modal';
import { IsMobile } from '../../../../../helpers/IsMobile';

import styles from './DeleteEmailModal.module.scss';

const DeleteEmailModal = ({ show, onHide, handleSubmit }) => {
  const { t } = useTranslation('common');
  const modalFullScreen = IsMobile();

  return (
    <Modal show={show} onHide={onHide} size="lg" centered fullscreen={modalFullScreen}>
      <Modal.CustomHeader closeButton>
        <Modal.Title>{t('emailModals.deleteEmail')}</Modal.Title>
      </Modal.CustomHeader>

      <Modal.Body>
        <div className={styles.container}>
          <div className={styles.modalContent}>
            <WarningIcon color="#EA5506" />
            <span>{t('emailModals.deleteWarning')}</span>
            <span>{t('emailModals.confirmRemoveEmail')}</span>
          </div>
        </div>
      </Modal.Body>

      <div className={styles.modalFooter}>
        <Modal.CustomFooter>
          <Button variant="primary" onClick={onHide}>
            {t('cancel')}
          </Button>
          <Button variant="outline-secondary" onClick={handleSubmit}>
            {t('confirm')}
          </Button>
        </Modal.CustomFooter>
      </div>
    </Modal>
  );
};

export default DeleteEmailModal;
